import React from 'react';
import { Users } from 'lucide-react';
export function QASlide() {
  return <div className="bg-gradient-to-br from-[#017C6D] to-[#0FB07D] rounded-2xl p-16 text-center min-h-[600px] flex flex-col items-center justify-center" data-id="element-180">
      <div className="mb-8" data-id="element-181">
        <div size={120} className="text-white mx-auto mb-6" data-id="element-182" />
      </div>

      <h1 className="text-6xl font-bold text-white mb-8" data-id="element-183">Questions?</h1>

      <p className="text-2xl text-white/90 mb-12 max-w-3xl" data-id="element-184">
        Drop your questions in the chat and let's talk about your specific
        situation
      </p>

      <div className="flex items-center gap-3 text-white/80 text-lg" data-id="element-185">
        <Users size={24} data-id="element-186" />
        <span data-id="element-187">This is your time - ask anything!</span>
      </div>
    </div>;
}
export default QASlide;